import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge,
  CLink
} from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { insert, update, remove } from 'src/services/PurchaseOrders';
import CIcon from '@coreui/icons-react';
import { cilTrash } from '@coreui/icons';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Select, { components } from 'react-select';
import { getAll } from 'src/services/Suppliers';
import { getForPO } from 'src/services/Products';
import { NumberFormatBase } from 'react-number-format';
import { getDetails } from 'src/services/PurchaseOrders';

import Moment from 'moment';
import formatter from 'src/reusables/formatter';
function PurchaseOrderActions() {
  let today = new Date();
  let todayMonth = today.getMonth() + 1;
  let todayYear = today.getFullYear();
  let todayDate = today.getDate();
  let showToday = todayYear + '-' + todayMonth + '-' + todayDate;
  const d = new Date();
  var month = ('0' + (d.getMonth() + 1)).slice(-2);
  var date = ('0' + d.getDate()).slice(-2);
  var datestringNow = d.getFullYear() + '-' + month + '-' + date;
  const [id, setID] = useState(0);
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [poNumber, setPONumber] = useState('');
  const [poDate, setPODate] = useState(Moment(showToday).format('YYYY-MM-DD'));
  const [grandTotal, setGrandTotal] = useState(0);
  const [uuid, setUUID] = useState('');
  const [temp, setTemp] = useState(0);
  const [type, setType] = useState(0);
  const [details, setDetails] = useState([
    {
      productID: 0,
      productName: '',
      price: 0,
      qty: 0,
      checked: 0,
      disabledC: 0
    }
  ]);
  const [items, setItems] = useState([]);

  const [selected, setSelected] = useState([]);
  const [ban, setBan] = useState([]);
  const [notes, setNotes] = useState('');
  let disabled1 = false;
  let slctd = [];
  let totPrice = 0;
  const dateMax = useState(datestringNow);
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');

  useEffect(() => {
    if (location.state) {
      setIsEdit(true);
      setID(location.state.id);
      setUUID(location.state.uuid);
      setNotes(location.state.notes);
      setSelectedSupplier({
        id: location.state.supplierID,
        label: location.state.supplierName,
        value: location.state.supplierID
      });
      fetchDetails(location.state.id);
    }

    fetchSuppliers();
    fetchProducts();
  }, [location.state]);
  useEffect(() => {
    if (type !== 1) {
      let total = 0;
      details.length > 0 &&
        details.forEach((item) => {
          total += item.price;

          setGrandTotal(total);
        });
    }
  }, [details]);
  const fetchDetails = async (x) => {
    let response = await getDetails(x);

    if (response.success === 1) {
      let data =
        response?.details.map((item) => {
          return {
            id: item.id,

            productID: item.productID,
            productName: item.productName,
            qty: item.qty,
            unitPrice: item.unit_price,
            price: item.total
          };
        }) ?? [];

      setDetails(data);
    }
  };
  const fetchSuppliers = async () => {
    let response = await getAll();

    if (response.success === 1) {
      let data =
        response?.suppliers.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id
          };
        }) ?? [];

      setSupplierOptions(data);
    }
  };
  const fetchProducts = async () => {
    let response = await getForPO();

    if (response.success === 1) {
      let data =
        response?.products.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id,
            cogs: item.cogs,
            name: 'items',
            type: 'menu',
            target: {
              label: `${item.name}`,
              id: item.id,
              value: item.id,
              cogs: item.cogs,
              name: 'items',
              type: 'menu'
            }
          };
        }) ?? [];

      setItems(data);
    }
  };
  async function fDelete() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message);
        setOpen(true);
        setColor('red');
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      let data = {
        id: id,
        supplierID: selectedSupplier.value,
        poNumber: poNumber,
        poDate: poDate,
        notes: notes,
        details: details,
        grandTotal: grandTotal
      };
      console.log(data);
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message);
            setOpen(true);
            setColor('red');
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get('errorMessage'));
            setOpen(true);
            setColor('red');
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }
  const handleDetailsChange = (e, index) => {
    const list = [...details];
    const { name, value } = e.target;

    if (name === 'unitPrice') {
      list[index]['price'] = parseFloat((value * list[index]['qty']).toFixed(2));
      list[index]['unitPrice'] = parseFloat(value).toFixed(2);
    } else if (name === 'items') {
      list[index]['productID'] = value;
      list[index]['productName'] = e.target.label;

      list[index]['qty'] = 1;
      list[index]['price'] = e.target.cogs * list[index]['qty'];
      list[index]['unitPrice'] = e.target.cogs;
    } else if (name === 'qty') {
      list[index]['price'] = list[index]['unitPrice'] * value;
      list[index][name] = value;
    } else {
      list[index][name] = value;
    }
    setDetails(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...details];
    list.splice(index, 1);
    setDetails(list);
  };

  const handleAddClick = () => {
    setDetails([
      ...details,
      {
        productID: 0,
        productName: '',

        checked: 0,

        price: 0,
        qty: 0,

        disabledC: 0
      }
    ]);
  };
  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />
      <CCardHeader>Actions - Purchase Order</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Tanggal PO</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="date"
                value={poDate}
                max={Moment(showToday).format('YYYY-MM-DD')}
                onChange={(e) => setPODate(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>{' '}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Supplier</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Cabang"
                value={selectedSupplier}
                options={supplierOptions}
                onChange={(e) => {
                  setSelectedSupplier(e);
                }}
                isDisabled={false}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Catatan</CFormLabel>&nbsp;
            </CCol>
            <CCol>
              <CFormInput type="text" value={notes} onChange={(e) => setNotes(e.target.value)} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol lg="3">
              <CFormLabel htmlFor="name">Daftar Barang</CFormLabel>
            </CCol>
            <CCol xs="12" lg="9"></CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xs="12" lg="12">
              <CRow>
                <CCol xs="5" className="pl-4">
                  Item
                </CCol>
                <CCol xs="2">Qty (Yards)</CCol>

                <CCol xs="2">Harga Satuan</CCol>
                <CCol xs="2">Total Harga</CCol>
                <CCol xs="1"></CCol>
              </CRow>
              {details &&
                details.map(
                  (
                    {
                      id,
                      qty,

                      price,

                      productID,
                      productName,

                      checked,
                      disabledC
                    },
                    index
                  ) => {
                    let disD = false;
                    let unitPrice = price / qty;
                    let item = {
                      id: productID,
                      value: productID,
                      label: productName,
                      type: 'product',
                      id_product: productID,

                      qty: qty,

                      checked: checked
                    };

                    if (!productID && disabled1 === false) {
                      disabled1 = true;
                    }
                    if (checked === 1 && disabledC === 0) {
                      slctd.push({ item: item });
                    }
                    totPrice += parseFloat(price);
                    let index1 = index;
                    return (
                      <>
                        <CCol>
                          &nbsp;
                          <CRow key={index}>
                            <CCol xs="5">
                              <Select
                                options={items}
                                name="item"
                                isDisabled={isEdit}
                                placeholder="Pilih item"
                                value={item}
                                onChange={(e) => handleDetailsChange(e, index)}
                              />
                            </CCol>
                            <CCol xs="2">
                              <NumberFormatBase
                                // isDisabled={type === 1 ? true : false}
                                // disabled=
                                disabled={isEdit}
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  border: '1px solid lightgray',
                                  borderRadius: '3px',
                                  paddingLeft: '10px',
                                  paddingRight: '10px'
                                }}
                                value={qty}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                onValueChange={(e) => {
                                  const list = [...details];
                                  if (e.floatValue) {
                                    list[index]['price'] = list[index]['unitPrice'] * e.floatValue;
                                    list[index]['qty'] = e.floatValue;
                                  } else {
                                    list[index]['price'] = NaN;
                                    list[index]['qty'] = '';
                                  }

                                  setDetails(list);
                                }}
                              />

                              {/* <CFormInput type="number" onWheel={(e) => e.target.blur()} disabled={type===1?true:false} placeholder="0" name="qty" value={qty} onChange={(e) => handleDetailsChange(e, index)}/> */}
                            </CCol>

                            <CCol xs="2">
                              <CFormInput
                                onWheel={(e) => e.target.blur()}
                                disabled={isEdit}
                                placeholder="0"
                                type="number"
                                // type='text'
                                name="unitPrice"
                                value={unitPrice ? parseFloat(unitPrice.toFixed(2)) : ''}
                                onChange={(e) => {
                                  handleDetailsChange(e, index);
                                }}
                              />
                            </CCol>
                            <CCol xs="2">
                              {/* <CFormInput
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        // disabled={type === 1 ? true : false}
                                        disabled={true}
                                        placeholder="0"
                                        name="price"
                                        value={price ? price.toFixed(2) : ""}
                                        onChange={(e) => {
                                          handleDetailsChange(e, index)
                                        }}
                                      /> */}
                              <NumberFormatBase
                                disabled={true}
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  border: '1px solid lightgray',
                                  borderRadius: '3px',
                                  paddingLeft: '10px',
                                  paddingRight: '10px'
                                }}
                                value={price ? parseFloat(price.toFixed(2)) : ''}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                              />
                            </CCol>

                            {isEdit ? (
                              <div></div>
                            ) : (
                              <CCol xs="1" hidden={type === 0 ? false : true}>
                                {details.length !== 1 && (
                                  <CButton color="danger" onClick={() => handleRemoveClick(index)}>
                                    <span style={{ color: 'white' }}> -</span>
                                  </CButton>
                                )}
                              </CCol>
                            )}
                          </CRow>
                        </CCol>
                      </>
                    );
                  }
                )}
              <br />
              <CRow>
                <CCol xs="9">
                  <p
                    style={{
                      textAlign: 'end',
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    Total:
                  </p>
                </CCol>
                <CCol xs="3">
                  <p
                    style={{
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    {formatter('currency', grandTotal || grandTotal === '0' ? grandTotal : grandTotal)}
                  </p>
                </CCol>
                <CCol xs="1">{''}</CCol>
              </CRow>
            </CCol>
          </CRow>
          {isEdit ? (
            <div></div>
          ) : (
            <CRow row>
              <CCol xs="10"></CCol>
              <CCol xs="2">
                <CButton color="primary" onClick={handleAddClick}>
                  Tambah
                </CButton>
              </CCol>
            </CRow>
          )}
        </div>
        <CCardFooter style={{ textAlign: 'right' }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                fDelete();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white'
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            {isEdit ? 'Back' : 'Cancel'}
          </CButton>
          &emsp;
          {isEdit ? (
            <CLink
              className="c-subheader-nav-link"
              href={'https://printer.movejuicetex.id/PurchaseOrders.php?uuid=' + uuid}
              target="_blank"
            >
              <CButton
                color="success"
                style={{
                  color: 'white'
                }}
              >
                Print PO
              </CButton>
            </CLink>
          ) : (
            <CButton
              color="success"
              style={{
                color: 'white'
              }}
              type="submit"
            >
              Save
            </CButton>
          )}
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default PurchaseOrderActions;
